import React, { useEffect, memo, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import MenuIcon from "../../../../../styles/img/hamburger-menu-icon.png";
import CloseIcon from "../../../../../styles/img/close-icon.png";
import WhiteLogo from "../../../../../styles/img/sb-logo-white.png";
import { UiRowContainer, UiCol } from "../../../grid-container/GridContainer";
import { isMobile } from "react-device-detect";
import Logo from "../../../../../styles/img/custom/renault-top-logo.png";
import FooterTermsLogo from "../../../../../styles/img/footer-terms-icon.png";
import { Context } from "../../../../../_context/Store";
import CookiePolicyModal from "../../../../pages/auth/CookiePolicyModal";
import { participantUrl,themeType, themeUrl } from "../../../../../_redux/_constants";
import {
    participantJobRoleIds,
    contextApiActions,
    participantTypeIds,
} from "../../../../../_redux/_constants";
import {
    campaignGetAreaManagerDealersRequest,
    campaignGetParticipantsByDealerRequest,
    getParticipantProfileRequest,
    getUSerDetailsRequest,
    userAccountLogUserLogStatusRequest,
    userDeviceRequest,
    campaignVChangeRole
} from "../../../../../_redux/_actions";
import SherbetLogo from "../../../../../styles/img/sherbet-main-logo.png"

export const UiTopNavBarWr = React.forwardRef((props, ref) => {
    const chatStyle = {
        // "@media only screen and (max-width: 1200px) and (min-width: 768px)": {
        //         // marginLeft: '-17rem !important',
        //         // marginRight:'21rem'
        //         .sb-topnabr-br-with-permission{
        //             marginLeft:-17rem;
        //             marginRight:'21rem'
        //         }
        // }
    };
    const actionDispatch = useDispatch();
    useEffect(() => {
        actionDispatch(getParticipantProfileRequest());
        actionDispatch(getUSerDetailsRequest());
        
    }, []);

    const { auth ,isChangeRole} = useSelector((state) => {
        return {
            auth: state.auth,
            isChangeRole: state.campaign.isChangeRole,
        };
    });
   
    return (
        <>
            <div
                className={isChangeRole ||
                    auth?.userProfileDetails?.jobRoleId ===
                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER 
                    
                        ? "sb-top-nav-national-manager"
                        : "sb-top-nav-service-manager"
                }
            >
                <div
                    className={
                        props.permission
                            ? "sb-top-nav-with-dealer"
                            : "sb-top-nav-no-dealer"
                    }
                >
                    <div
                        className={
                            props.isActive
                                ? "sb-top-nav-wr__nav-bar expand"
                                : "sb-top-nav-wr__nav-bar d-lg-block collapsed "
                        }
                        ref={ref}
                    >
                        <ul>{props.children}</ul>
                        <span
                            onClick={props.close}
                            className="sb-mobile-nav-close"
                        >
                            <img src={CloseIcon} />
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
});

const UiTopNavItem = React.forwardRef((props, ref1) => {
    const handleClick = () => {
        window.open(props.url);
    };

    useEffect(function () {
        window.addEventListener("scroll", () => {
            if (!isMobile) {
                let scrollTop = window.scrollY;
                let activeLink = document.querySelector(
                    ".sb-slider-bottom-line",
                );
                let topBorder = document.querySelector(".border-top");
                let bottomBorder = document.querySelector(".border-bottom");
                let activeLinkText = document.querySelector(".active-link");
                if (
                    activeLink !== null &&
                    topBorder !== null &&
                    activeLinkText !== null &&
                    bottomBorder !== null
                ) {
                    if (scrollTop >= activeLink.offsetTop) {
                        // topBorder.style.backgroundColor = "#fff";
                        // bottomBorder.style.backgroundColor = "#fff";
                        // activeLinkText.classList.add("link-color");
                        // activeLinkText.classList.remove("active-link-add");
                    } else {
                        // topBorder.style.backgroundColor = "#FD7D56";
                        // bottomBorder.style.backgroundColor = "#FD7D56";
                        // activeLinkText.classList.remove("link-color");
                        // activeLinkText.classList.add("active-link-add");
                    }
                }
            }
        });
    });

    return (
        <>
            <li>
                <>
                    {props.externalLink ? (
                        <div className="sb-help-btn-wr">
                            <NavLink
                                onClick={() => {
                                    {
                                        props.clickEvent
                                            ? props.onClick()
                                            : handleClick();
                                        props.onClick();
                                    }
                                }}
                                className="sb-external-link"
                            >
                                <>{props.label}</>
                            </NavLink>
                        </div>
                    ) : (
                        <NavLink
                            to={props.pathname}
                            ref={ref1}
                            className={(props) => {
                                return props.isActive
                                    ? "active-link active-link-add"
                                    : "";
                            }}
                            onClick={props.onClick}
                        >
                            {({ isActive }) => {
                                return isActive ? (
                                    <>
                                        <span className="sb-nav-bar-active-border border-top"></span>
                                        {props.label}
                                        <span className="sb-nav-bar-active-border border-bottom"></span>
                                    </>
                                ) : (
                                    <>{props.label}</>
                                );
                            }}
                        </NavLink>
                    )}
                </>
            </li>
        </>
    );
});

export default UiTopNavItem;

export const UiMobileNavBar = (props) => {
    return (
        <div className="sb-mobile-top-navbar d-xl-none ">
            <div className="sb-mobile-top-navbar__wrapper">
                <i
                    className="sb-mobile-top-navbar__hamburger-icon"
                    onClick={props.toggle}
                >
                    <img src={MenuIcon} />
                </i>
                <div className="sb-mobile-top-navbar__separator"></div>
            </div>
        </div>
    );
};

export const UiHeaderLogo = (props) => {
    useEffect(() => {
        if (props.permission) {
            document.title = "Sherbet ";
        } else {
            document.title = "Sherbet";
        }
    }, [props.permission]);

    let tenantId = 'de5b2093-01b7-40d0-afc9-c091e52dbddb-s';
    return (
        <div onClick={props.onClick} className="sb-top-nav-wr__logo">
            {tenantId == themeType.SHERBET ? <img
                src={SherbetLogo}
                alt="logo"
                className="sb-top-sherbet-logo"
               
            />
            :
            <><img
                src={props.logo}
                alt="logo"
                className="sb-top-bg-logo"
               
            />
            {props.permission ? (
                <h3>ÉQUIPE</h3>
            ) : (
                <h3 className="sb-tlc-logo">TLC</h3>
            )}
            </>
        }
            {/* <img
                src={WhiteLogo}
                alt="logo"
                className="sb-top-bg-reverse-logo"
                style={
                    props.whiteLogo ? { display: "block" } : { display: "none" }
                }
            /> */}
        </div>
    );
};

export const UiLoginContainer = memo((props) => {
    return (
        <div className="sb-login-page-container">
            <header>{props.children}</header>
        </div>
    );
});

export const UiLoginPageLogo = (props) => {
    return (
        <div className="sb-login-page-logo">
            <img src={props.Logo} alt="logo" />
            {props.heading && <h3>{props.heading}</h3>}
        </div>
    );
};

export const UiLoginOptions = (props) => {
    return (
        <>
            {props.signin && (
                <a className="sb-login-link" onClick={props.signin}>
                    Sign In
                </a>
            )}

            {props.signin && props.signup && <span>/</span>}
            {props.signup && (
                <a className="sb-login-link" onClick={props.signup}>
                    {" "}
                    Sign Up{" "}
                </a>
            )}
        </>
    );
};

export const UiAuthContainer = (props) => {
    const [state, dispatch] = useContext(Context);

    const domainName = window.location.hostname;
    const [host, setHost] = useState(domainName);


    useEffect(() => {
        const hostname = window.location.hostname;
        setHost(hostname)
        // Set the title based on the domain name
        if (hostname === participantUrl.RENAULT_TLC_URL) {
            document.title = "Renault Group";
        } else if (hostname === participantUrl.EQUIPE_URL) {
            document.title = "Renault Group";
        } else {
            document.title = "Sherbet"; // Default title
        }
    }, []);

    const showCookieModal = () => {
        dispatch({
            type: "LARGE_MODAL",
            payload: {
                show: true,
                title: "Cookie Policy",
                subTitle: "Keeping you informed",
                children: <CookiePolicyModal />,
            },
        });
    };

    return (
        <div className={host == themeUrl.SHERBET_URL ? "sb-login-page-custom-container sb-login-renault-bg" :"sb-login-page-custom-container sb-login-sherbet-bg"}>
            <header>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12">
                        <UiLoginPageLogo
                            Logo={host == themeUrl.SHERBET_URL ? Logo : SherbetLogo}
                            // heading={
                            //     domainName == participantUrl.RENAULT_TLC_URL
                            //         ? "TLC"
                            //         : domainName == participantUrl.EQUIPE_URL
                            //         ? "ÉQUIPE"
                            //         : "ÉQUIPE"
                            // }
                        />
                    </UiCol>
                </UiRowContainer>
            </header>
            <div className="sb-login-footer-terms-wr">
                <div
                    className="sb-login-page-footer-icon"
                    onClick={showCookieModal}
                >
                    <img src={FooterTermsLogo} />
                </div>
            </div>
            {props.children}
        </div>
    );
};

export const UiAuthFooterContainer = (props) => {
    const hostname = window.location.hostname;

    useEffect(() => {
        // Set the title based on the domain name
        if (hostname === participantUrl.RENAULT_TLC_URL) {
            document.title = "Renault Group";
        } else if (hostname === participantUrl.EQUIPE_URL) {
            document.title = "Renault Group";
        } else {
            document.title = "Renault Group"; // Default title
        }
    }, []);

    return (
        <>
            {hostname.includes(participantUrl.RENAULT_TLC_URL) ? (
                <p className="sba-login-bottom-support-mail">
                    Contact: support@renaulttlc.com for any queries
                </p>
            ) : (
                <p className="sba-login-bottom-support-mail">
                    Contact: support@rgequipe.com for any queries
                </p>
            )}
        </>
    );
};
